export const AUDIO_DECMIALS = 18
export const WAUDIO_DECMIALS = 8
export const CURRENT_USER_EXISTS_LOCAL_STORAGE_KEY = '@audius/libs:found-user'
export enum AuthHeaders {
  MESSAGE = 'Encoded-Data-Message',
  SIGNATURE = 'Encoded-Data-Signature'
}
